import React, { useState } from "react";
import { Link } from "react-router-dom";
import "./index.css";

/*
The main menu items.
The type determines if the item appears as a white text or a yellow button
*/
const menuItems = [
  {
    label: "Home",
    link: "/",
    type: "link",
  },
  {
    label: "Games",
    link: "/games",
    type: "link",
  },
  {
    label: "Ranks",
    link: "/ranks",
    type: "link",
  },
  {
    label: "About Us",
    link: "/aboutus",
    type: "link",
  },
  {
    label: "Gallery",
    link: "/gallery",
    type: "link",
  },
  {
    label: "Join us",
    link: "https://discord.gg/5thmarineregiment",
    type: "button",
  },
  {
    label: <img src="/images/insta.png" alt="Instagram" width="25" height="25" />,
    link: "https://www.instagram.com/5th_marine_regiment_/",
    type: "link",
  },
  {
    label: <img src="/images/Tiktok.png" alt="TikTok" width="22" height="25" />,
    link: "https://www.tiktok.com/@5thmr_",
    type: "link",
  },
  {
    label: <img src="/images/youtube.png" alt="Youtube" width="25" height="25" />,
    link: "https://www.youtube.com/@5thmr ",
    type: "link",
  },
  {
    label: <img src="/images/admin5.png" alt="Command Hub" width="28" height="23" />,
    link: "https://command-hub.5thmrcommandhub.workers.dev",
    type: "link",
  },
];

const MainMenu = () => {
  const [isMobileMenuOpen, setIsMobileMenuOpen] = useState(false);

  const toggleMobileMenu = () => {
    setIsMobileMenuOpen(!isMobileMenuOpen);
  };

  const closeMobileMenu = () => {
    setIsMobileMenuOpen(false);
  };

  return (
    <>
      {/* Mobile Menu Button */}
      <button
        className="mobile-menu-button"
        onClick={toggleMobileMenu}
        aria-label="Toggle mobile menu"
      >
        <span className="hamburger-line"></span>
        <span className="hamburger-line"></span>
        <span className="hamburger-line"></span>
      </button>

      {/* Desktop Menu */}
      <ul className="main-menu desktop-menu">
        {menuItems.map((menuItem, index) => (
          <li
            key={index}
            className={menuItem.type === "button" ? "button" : "link"}
          >
            <Link to={menuItem.link}>{menuItem.label}</Link>
          </li>
        ))}
      </ul>

      {/* Mobile Menu Overlay */}
      {isMobileMenuOpen && (
        <div className="mobile-menu-overlay" onClick={closeMobileMenu}>
          <div
            className="mobile-menu-content"
            onClick={(e) => e.stopPropagation()}
          >
            <button
              className="mobile-menu-close"
              onClick={closeMobileMenu}
              aria-label="Close mobile menu"
            >
              ×
            </button>
            <ul className="mobile-menu">
              {menuItems.map((menuItem, index) => (
                <li
                  key={index}
                  className={menuItem.type === "button" ? "button" : "link"}
                >
                  <Link to={menuItem.link} onClick={closeMobileMenu}>
                    {menuItem.label}
                  </Link>
                </li>
              ))}
            </ul>
          </div>
        </div>
      )}
    </>
  );
};

export default MainMenu;
